angular.module('impactx.condition').controller('ConditionPrepDialogCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    'dataGen',
    'TranslationService',
    'AppConfiguration',
    'disId',
    ConditionPrepDialogCtrl]);

function ConditionPrepDialogCtrl($scope, $mdDialog, themeFactory, dataGen, TranslationService, AppConfiguration, disId) {
    var ctrl = this;
    $scope.theme = themeFactory.getTheme();
    $scope.disId = disId;
    $scope.data = {csc: {}, cat: {}, vcat: {}};
    $scope.currentCSC = null;
    $scope.wizardIndex = 0;
    $scope.useVCATSelection = AppConfiguration.get("useVCATSelectionOnVariableCosts");

    $scope.forwardLabel = TranslationService.get("forward");
    $scope.abortLabel = TranslationService.get("abort");
    $scope.backLabel = TranslationService.get("back");

    dataGen.getData({}, {disId: disId}, "/condition/variablecosts/selection/csc").then(function (data) {
        $scope.trns = data.trns;
        $scope.data.csc = data.data;
    });
    ctrl.getCatalogEntries = function () {
        dataGen.getData({}, {cscId: $scope.data.csc.selected.id},
            "/condition/variablecosts/selection/cat").then(function (data) {
            $scope.data.cat = data.data;
        });
    };

    ctrl.getVCATEntries = function () {
        dataGen.getData({}, {cscId: $scope.data.csc.selected.id, catId: $scope.data.cat.selected.id},
            "/condition/variablecosts/selection/vcat").then(function (data) {
            $scope.data.vcat = data.data;
        });
    };

    this.forward = function () {
        if ($scope.wizardIndex === 0 && impactX.isDefined($scope, "data.csc.selected")) {
            $scope.wizardIndex++;
            if($scope.currentCSC === null && $scope.currentCSC !== $scope.data.csc.selected)
                ctrl.getCatalogEntries();
        }
        else if ($scope.wizardIndex === 1 && impactX.isDefined($scope, "data.cat.selected")) {
            if ($scope.useVCATSelection) {
                $scope.wizardIndex++;
                ctrl.getVCATEntries();
            }
            else {
                ctrl.finish();
            }
        }
        else if ($scope.wizardIndex === 2) {
            ctrl.finish();
        }
    };

    this.back = function () {
        $scope.errorMessage = null;
        switch($scope.wizardIndex)
        {
            case 1:
                $scope.data.cat.selected = null;
                $scope.currentCSC = $scope.data.csc.selected;
            case 2:
                $scope.data.vcat.selected = null;
        }
        if ($scope.wizardIndex > 0) {
            $scope.wizardIndex--;
        }
    };

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.finish = function () {
        if($scope.data.csc.selected.id > 0 &&
            $scope.data.cat.selected.id > 0) {
            $mdDialog.hide({
                cscId: $scope.data.csc.selected.id,
                catId: $scope.data.cat.selected.id,
                vcatId: $scope.useVCATSelection && impactX.isDefined($scope, "data.vcat.selected.id") ? $scope.data.vcat.selected.id : 0
            });
        }
    };
}